import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { I18nextProvider } from 'react-i18next';
import { ReactKeycloakProvider } from '@react-keycloak/web';
import Router from './router/Router';
import keycloak from './services/authentication/Keycloak';
import { jwtReqInterceptor, jwtResInterceptor } from './helpers/interceptor';
import './localization/i18next';
import store from './redux/store';
import i18n from './localization/i18next';
import { config } from './config';
import { clear_keycloak_session, sync_keycloak_session } from './services/authentication/keycloak_user_utils';
import { should_bootstrap_keycloak } from './services/authentication/auth_urls';
import packageInfo from '../package.json';

window.__APP_VERSION__ = packageInfo.version;

const shouldBootstrapKeycloak = should_bootstrap_keycloak();
const keycloakSessionFailureEvents = new Set([
    'onAuthError',
    'onAuthLogout',
    'onAuthRefreshError',
    'onInitError'
]);

const keycloakOptions = config.usesCentralAuth ? {
    onLoad: 'check-sso',
    checkLoginIframe: false
} : {
    onLoad: 'check-sso',
    checkLoginIframe: false
};

const root = ReactDOM.createRoot(document.getElementById('root'));

jwtReqInterceptor();
jwtResInterceptor();

const app = (
    <Provider store={store}>
        <BrowserRouter>
            <I18nextProvider i18n={i18n}>
                <Router />
            </I18nextProvider>
        </BrowserRouter>
    </Provider>
);

root.render(
    shouldBootstrapKeycloak ? (
        <ReactKeycloakProvider
            authClient={keycloak}
            initOptions={keycloakOptions}
            LoadingComponent={<div></div>}
            onEvent={(eventType) => {
                if (keycloakSessionFailureEvents.has(eventType)) {
                    clear_keycloak_session();
                }
            }}
            onTokens={(tokens) => {
                sync_keycloak_session(keycloak, tokens);
            }}
        >
            {app}
        </ReactKeycloakProvider>
    ) : app
);
